import { createSetVehiclesDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useVehiclesData = (params, dataFresh) => {
  return useGetAndSet("vehicles", params, createSetVehiclesDataAction, dataFresh);
};
